export default async function checkGuest({ next }) {
  if (localStorage.getItem("token_signage")) {
    next("/");
  } else next();
}
